import React from 'react';

interface StepProgressIndicatorProps {
	steps: string[];
	currentStep: string;
}

export const StepProgressIndicator: React.FC<StepProgressIndicatorProps> = ({
	steps,
	currentStep
}) => {
	const currentStepIndex = steps.indexOf(currentStep);

	if (currentStepIndex === -1 && steps.length > 0) {
		console.warn(
			'Current step not found in steps array, defaulting to first step:',
			currentStep,
			steps
		);
	}

	return (
		<div className="flex w-full mb-12 relative justify-between">
			{steps.map((step, index) => {
				const isCompleted = currentStepIndex > index;
				const isCurrent = currentStepIndex === index;

				return (
					<div key={step} className="flex flex-col items-center relative flex-1 z-10">
						{/* Step Connector */}
						{index < steps.length - 1 && (
							<div
								className={`absolute top-4 left-[calc(50%+16px)] right-[calc(50%-16px)] h-[3px] z-0 transition-all duration-300 ease-in-out ${
									isCompleted
										? 'bg-gradient-to-r from-blue-500 to-indigo-500'
										: 'bg-gray-200'
								}`}
							/>
						)}

						{/* Step Circle */}
						<div
							className={`
                w-12 h-12 flex items-center justify-center rounded-full mb-2 transition-all duration-300 z-20
                ${
					isCompleted
						? 'bg-gradient-to-br from-blue-500 to-indigo-500 shadow-md shadow-blue-300/30 text-white'
						: isCurrent
						? 'bg-white border-2 border-blue-500 shadow-[0_0_0_4px_rgba(59,130,246,0.15)] text-blue-500 scale-110'
						: 'bg-gray-50 border-2 border-gray-200 text-gray-500'
				}
              `}
						>
							{isCompleted ? (
								<svg className="w-[18px] h-[18px] fill-current" viewBox="0 0 24 24">
									<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
								</svg>
							) : (
								<span className="text-sm font-semibold">{index + 1}</span>
							)}
						</div>

						{/* Step Label */}
						<span
							className={`
                text-xs md:text-sm font-medium text-center transition-colors duration-300 max-w-full px-3
                ${
					isCurrent
						? 'text-blue-500 font-semibold'
						: isCompleted
						? 'text-gray-600'
						: 'text-gray-400'
				}
              `}
						>
							{/* On mobile, display shorter version if step name is long */}
							<span className="hidden md:inline">{step}</span>
							<span className="md:hidden">
								{step.length > 10 ? step.split(' ')[0] : step}
							</span>
						</span>
					</div>
				);
			})}
		</div>
	);
};
